import dayjs from 'dayjs';
import { UsersTopBar } from 'features/users/components/top-bar/users-top-bar';
import { UsersTable } from 'features/users/components/users/users-table';
import { UserFilterFormsValues } from 'features/users/components/users-filter-form/types';
import { useGetUsersList } from 'features/users/use-cases/get-users';
import { useUserContext } from 'features/users/user-context';
import { usePaginationParams } from 'hooks';
import { omit } from 'lodash';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { formatDate } from 'utils/date';
// ../user-context
const getInitialFilterValues: UserFilterFormsValues = {
  Name: undefined,
  RoleName: undefined,
  Email: undefined,
  IsActive: undefined,
  CreatedDate: undefined,
  date: [undefined, undefined],
};

export const AdminUsersView = () => {
  const { user, menuItem, companyUser } = useUserContext();
  const navigate = useNavigate();
  const { params, updateParams, resetPage } = usePaginationParams<any>({
    PageIndex: 1,
    RecordPerPage: 10,
    CompanyId: user?.CompanyId,
    ...getInitialFilterValues,
  });
  const preparePayload: any = (paramsw: any) => {
    const createdAtFrom = paramsw.date?.[0];
    const createdAtTo = paramsw.date?.[1];

    return {
      ...omit(params, ['date']),
      CreatedDate: paramsw?.CreatedDate
        ? dayjs(paramsw.CreatedDate).format('YYYY-MM-DD')
        : null,
      LastUpdateFrom: createdAtFrom
        ? formatDate({
            date: dayjs(createdAtFrom).startOf('day'),
            format: 'isoDate',
          })
        : undefined,
      LastUpdateTo: createdAtTo
        ? formatDate({
            date: dayjs(createdAtTo).startOf('day'),
            format: 'isoDate',
          })
        : undefined,
    };
  };
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const getUsersListQueryResponse = useGetUsersList(
    preparePayload(params), // Directly pass `params`
    {
      retry: false, // Disable retry if the query fails
    },
  );
  const handleFiltersChange = (values: UserFilterFormsValues) => {
    updateParams(values);
    resetPage();
  };
  useEffect(() => {
    if (menuItem?.rc[0]?.Url === 'dashboard') {
      navigate('/dashboard');
    }
  }, [menuItem?.rc[0]?.Url, navigate]);
  useEffect(() => {
    if (!companyUser?.rc || companyUser.rc.length === 0) {
      navigate('/no-company'); // Redirect to "not found" route
    }
  }, [companyUser?.rc, navigate]);
  
return (
    <>
      <UsersTopBar
        showAddUserModal={showAddUserModal}
        setShowAddUserModal={setShowAddUserModal}
        handleFilter={handleFiltersChange}
        getInitialFilterValues={getInitialFilterValues}
      />
      <UsersTable
        isUsersListLoading={getUsersListQueryResponse.isFetching}
        usersList={getUsersListQueryResponse?.data?.rc || []}
        itemsCount={getUsersListQueryResponse.data?.total || 0}
        tableParams={params}
        updateParams={updateParams}
      />
      <Outlet />
    </>
  );
};
